import { ReactElement, useCallback, useEffect, useState } from 'react';
import { AxiosResultDefaultError } from '../../../api/request';
import DisplayError from '../../../components/info/DisplayError';
import Loading from '../../../components/info/Loading';
import { useLoadingState } from '../../../hooks/useLoadingState';
import { getStartSurveyData } from '../requests';
import { StartSurveyData } from '../types';
import { useParams } from 'react-router-dom';

export interface CoursesLoaderProps {
  children: (startSurveyData: StartSurveyData) => ReactElement;
}

export function StartSurveyLoader({ children }: CoursesLoaderProps) {
  const { sectionId } = useParams<{
    sectionId: string;
  }>();
  const { loading, setLoading } = useLoadingState();
  const [startSurveyData, setStartSurveyData] = useState<StartSurveyData>();
  const [error, setError] = useState<AxiosResultDefaultError>();

  const load = useCallback(async () => {
    setLoading(true);

    const startSurveyDataResponse = await getStartSurveyData(sectionId);
    if (startSurveyDataResponse.data) {
      setStartSurveyData(startSurveyDataResponse.data);
      setError(undefined);
    }
    if (startSurveyDataResponse.error) {
      setError(startSurveyDataResponse.error);
    }

    setLoading(false);
  }, [setLoading, sectionId]);

  useEffect(() => {
    load();
  }, [load]);

  if (error) {
    return (
      <DisplayError
        insideCard
        body={error.code}
        retryAction={load}
        loadingAction={loading}
      />
    );
  }

  if (loading) {
    return <Loading insideCard />;
  }

  if (!startSurveyData) {
    return (
      <DisplayError
        insideCard
        body="Data no cargada"
        retryAction={load}
        loadingAction={loading}
      />
    );
  }

  return children(startSurveyData);
}
